module.exports = __webpack_public_path__ + "static/media/toool-light-logo.f683ef00.png";